module.exports = __webpack_public_path__ + "static/media/First5_Post01-Image.e642d47f.jpg";